import { render } from "./commandbar.vue?vue&type=template&id=51a2fb44"
import script from "./commandbar.vue?vue&type=script&lang=js"
export * from "./commandbar.vue?vue&type=script&lang=js"

import "./commandbar.vue?vue&type=style&index=0&id=51a2fb44&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__